import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {FileDataService} from "../../services/FileDataService";
import {MapAreaService} from "../../services/MapAreaService";
import {MapArea} from "../../entities/MapArea";

export class CmdCenterEditAreaModel {
    mapArea:MapArea;
    mapAreaId:number;
    mapSiteId:number;
    imageWidth:number;
    imageHeight:number;
    geo1X:number;
    geo1Y:number;
    geo2X:number;
    geo2Y:number;
    width:any = 0;
    height:any = 0;
    measureType:string;
    measureTypePlural:string;
    useMeters:boolean;
    static $inject = ['$q','MapAreaService','FileDataService','ApplicationSettingService','NotificationService','FileSaver','Blob'];
    constructor(public $q:ng.IQService,
                public mapAreaService:MapAreaService,
                public fileDataService:FileDataService,
                public applicationSettingService:ApplicationSettingService,
                public notificationService:NotificationService,
                public FileSaver:any,
                public Blob:any)
    {
    }
    init(mapSiteId:number, mapAreaId:number):ng.IPromise<any> {
        this.mapAreaId = mapAreaId;
        this.mapSiteId = mapSiteId;
        var mainPromise:ng.IPromise<any> = null;
        this.applicationSettingService.getCached().then((data)=>{
          this.useMeters = data.useMeters;
          this.measureType = this.useMeters ? "Meter" : "Foot";
          this.measureTypePlural = this.useMeters ? "Meters" : "Feet";
        });
        if(isNaN(this.mapAreaId))
            mainPromise = this.$q.when<MapArea>(null);
        else
            mainPromise = this.mapAreaService.get(this.mapAreaId);
        return mainPromise.then((data:any)=> {
            this.mapArea = (data == null) ? new MapArea(null, this.mapSiteId) : data;
            // Modified 02/06/19 by BA to convert PPM from database to pixels per display unit for display purposes
            if (!this.useMeters) {
              this.mapArea.pixelsPerMeter *= 0.3048;
            }
            if(isNaN(this.mapAreaId))
                return this.$q.when<any>(null);
            else
                return this.fileDataService.getImageSize(this.mapArea.fileDataID);
        }).then((data:any)=> {
            if (data != null) {
                var dataArr:string[] = data.split("x");
                this.imageWidth = parseInt(dataArr[0]);
                this.imageHeight = parseInt(dataArr[1]);
                // Recalculate the width and height in display units
                this.height = Math.round(this.imageHeight / this.mapArea.pixelsPerMeter);
                this.width = Math.round(this.imageWidth / this.mapArea.pixelsPerMeter);
            }
            return this.$q.when<boolean>(true);
        });
    }
    uploadImage(b64Data:string):ng.IPromise<number> {
        return this.fileDataService.insert(b64Data)
        .then((id)=> {
            this.mapArea.fileDataID = id;
            return this.fileDataService.getImageSize(id);
        })
        .then((size)=>{
                var dataArr:string[] = size.split("x");
                this.imageWidth = parseInt(dataArr[0]);
                this.imageHeight = parseInt(dataArr[1]);
                this.mapArea.imageWidth = this.imageWidth;
                this.mapArea.imageHeight = this.imageHeight;
            return this.$q.when<number>(this.mapArea.fileDataID);
        })
        .catch((exc)=> {
            this.notificationService.notifyError("Got error uploading image: " + exc);
            return this.$q.when<number>(null);
        });
    }
    getBaseUrl():string{
        return this.fileDataService.getBaseUrl();
    }
    getMapAreaImage():ng.IPromise<string>{
      return this.fileDataService.get(this.mapArea.fileDataID).then((b64Data)=>{
        return this.$q.when<string>(b64Data);
      });
    }
    save():ng.IPromise<boolean>{
        var errorMsg:string = null;
        let lower_limit: number = (this.useMeters ? 0.002 : 0.0006);
        let limit_unit: string = (this.useMeters ? "Meter" : "Foot");
        if(this.mapArea.name == null || this.mapArea.name.length == 0)
            errorMsg = "Please enter a name before saving";
        if(isNaN(this.mapArea.pixelsPerMeter))
            errorMsg = "Please set either width or height to adjust Pixels Per "+this.measureType;
        else if(this.mapArea.pixelsPerMeter < lower_limit) {
            errorMsg = "Please adjust width/height so that Pixels Per " + limit_unit + " is more than " + lower_limit;
        }
        if(this.mapArea.fileDataID == null)
            errorMsg = "Please upload an image first.";
        if(isNaN(this.mapArea.floorLevel) || this.mapArea.floorLevel < 1 || this.mapArea.floorLevel > 100)
            errorMsg = "Please enter a valid number between 1 and 100";
        if(errorMsg != null){
            this.notificationService.notify(errorMsg);
            return this.$q.when<boolean>(false);
        }
        var mapArea = new MapArea();
        mapArea.parseJson(this.mapArea);
        if(!this.useMeters){
          // Modified 02/06/19 by BA to convert displayed units to pixels per meter for storage purposes
          mapArea.pixelsPerMeter = mapArea.pixelsPerMeter / 0.3048;
        }
        var mainPromise:ng.IPromise<any> = null;
        if(isNaN(this.mapAreaId))
            mainPromise = this.mapAreaService.insert(mapArea);
        else
            mainPromise = this.mapAreaService.update(mapArea);
        return mainPromise.then((data)=>{
            if(typeof(data) !== "boolean")
            {
                this.mapAreaId = data;
                this.mapArea.id = data;
            }
            return this.$q.when<boolean>(true);
        })
        .catch((err:any)=>{
            alert("Error in editAreaModel.save "+err);
            return this.$q.when<boolean>(false);
        });
    }
    export():ng.IPromise<boolean> {
        var errorMsg:string = null;
        if(this.mapArea.fileDataID == null)
            errorMsg = "Please upload an image first.";
        if(errorMsg != null){
            this.notificationService.notify(errorMsg);
            return this.$q.when<boolean>(false);
        }
        this.$q.all([
            this.fileDataService.getImageType(this.mapArea.fileDataID),
            this.fileDataService.get(this.mapArea.fileDataID)
        ]).then((data) => {
            var imageType:string = data[0];
            var imageBytes:string = atob(data[1]);
            var bytes = new Array(imageBytes.length);
            for (var i = 0; i < imageBytes.length; i++) {
                bytes[i] = imageBytes.charCodeAt(i);
            }
            var fileBlob = new this.Blob([new Uint8Array(bytes)], { type: 'image/'+imageType });
            this.FileSaver.saveAs(fileBlob, 'Image.'+imageType);
            return this.$q.when<boolean>(true);
        })
        .catch((err:any)=>{
            alert("Error in editAreaModel.export "+err);
            return this.$q.when<boolean>(false);
        });
        return this.$q.when<boolean>(false);
    }
}
